import { getSecureBaseUrl } from '../../../services/UrlMapperService';
import { HttpService } from '../../../services/HttpService';
import { eventDispatcher } from '../Tagging';

// import { getSessionStorageInfo } from './helpers';

import { getParameterByName, getBrowserName, getPageName, crossSiteCheckUrl, isLoggedIn, logToContentSquare, getAPPID } from '../Helpers';
import { errorLoggingPatterns } from './constants';

const redirectCheck = (data) => {
  const enableJSFailureRedirectFlag = document?.getElementById('enableJSFailureRedirect')?.value || 'N';
  if (enableJSFailureRedirectFlag === 'Y' && !getParameterByName('ts')) {
    // Adding check for query param so that we don't redirect more than once.

    const knownErrorStrings = ['ChunkLoadError', 'Loading chunk', 'chunkId is not defined', "Can't find variable: chunkId"];

    let fileLoadError = knownErrorStrings.some((s) => (data?.loggerMessage?.stack || '').includes(s));
    if (!fileLoadError) {
      fileLoadError = knownErrorStrings.some((s) => (data?.loggerMessage?.message || '').includes(s));
    }

    if (fileLoadError) {
      if (window.location.search && window.location.search !== '') {
        // Query Params are present
        window.location.href = crossSiteCheckUrl(`${window.location.href}&ts=${Date.now()}`);
      } else {
        window.location.href = crossSiteCheckUrl(`${window.location.href}?ts=${Date.now()}`);
      }
    }
  }
};

const jsNotifyAsDynamic = (data) => {
  HttpService.post(`${getSecureBaseUrl(true)}/peripheralsservice/jsNotifyAsDynamic`, data)
    .then(() => {
      redirectCheck(data);
    })
    .catch((e) => {
      console.log(e);
      redirectCheck(data);
    });
};

const getErrorJSON = (err) => {
  const errorJSON = {};
  Object.getOwnPropertyNames(err).forEach((key) => {
    errorJSON[key] = err[key];
  });
  return errorJSON;
};

const getWindowErrorJSON = (error) => ({
  message: error.error.message,
  stack: error.error.stack,
});

const getDisplayMessage = (errorCode, errorMessage) => {
  const couponCodeErrorMessages = {
    '3418': 'Promo code not found',
    '3419': 'Promo code already redeemed',
    '15510': "Promo code doesn't qualify for this order",
  };
  return couponCodeErrorMessages[errorCode] || errorMessage;
};

const getNetworkJSON = (data) => {
  const { error = {}, subEventType } = data;
  let { response } = data;
  let errorType = null;
  let errorTypeDescription = null;
  // If response key exists and response value is empty/null/undefined it means the request is denied / cancelled.
  if (Object.keys(data).indexOf('response') > 0 && !response && !error?.message) {
    response = {};
    response.status = 'CANCELLED/ABORTED';
    response.message = 'Request cancelled or aborted';
    response.config = {};
    errorType = 'soe';
    errorTypeDescription = 'Cancelled/Aborted';
  }

  const errorsResponse = error?.data?.errors ?? [{}];
  const { errors } = (response && response.data) || {};
  let [errorNode] = errors || errorsResponse || [{}];

  const hasResponse = !!(response && response.data && Object.keys(response.data));
  const hasServiceErrors = errors && errors.length > 0;
  const isGoToUrl = !!(response && response.data && (response.data.goToUrl || response.data.null));
  const isServiceErrorMessage = !!(errorNode && (errorNode.networkMessage || errorNode.message));

  const message = errorNode ? errorNode.networkMessage || errorNode.message || (error && error.message) : error && error.message;
  const namespace = errorNode?.namespace || errorNode?.networkMessage || '';
  const serviceErrMsg = errorNode?.serviceErrMsg || errorNode?.networkMessage || '';
  const errorNodeReceived = !!(errors?.length > 0);

  const { cfeMsg, msgType } = errorNode || {};
  let isNetworkError = false;
  let isAbortedError = false;

  if (response?.config?.url && response?.message) {
    const networkErrorsRegEx = ['Network Error', 'timeout of.*exceeded', 'Request failed with status code*', 'Request cancelled or aborted'];
    const abortedErrorsRegEx = ['Request aborted'];

    // Check if it's a Network Error
    isNetworkError = networkErrorsRegEx.some((item) => {
      const networkRegEx = new RegExp(item, 'i');
      return networkRegEx.test(response?.message || '');
    });

    // Check if it's a connection aborted error
    isAbortedError = abortedErrorsRegEx.some((item) => {
      const abortedRegEx = new RegExp(item, 'i');
      return abortedRegEx.test(response?.message || '');
    });
  }
  const { downstream = {} } = errorLoggingPatterns || {};
  const { timeouts: downstreamTimeouts = {}, exceptions: downstreamExceptions = {} } = downstream || {};
  if (downstreamTimeouts?.enable && downstreamTimeouts?.replacePatterns?.length > 0 && hasServiceErrors) {
    // DownStream Timeout Error
    const isDwTimeoutServiceErrMsg = downstreamTimeouts?.replacePatterns?.find?.(
      (item) => errorNode?.serviceErrMsg && errorNode?.serviceErrMsg?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1,
    );
    const isDwTimeoutMsg = downstreamTimeouts?.replacePatterns?.find?.(
      (item) => errorNode?.message && errorNode?.message?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1,
    );
    const isDwTimeoutName = downstreamTimeouts?.replacePatterns?.find?.(
      (item) =>
        errorNode?.name &&
        errorNode?.name?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1 &&
        errorNode?.name?.toLowerCase?.().indexOf('_exception'?.toLowerCase?.()) === -1,
    );
    if (isDwTimeoutServiceErrMsg || isDwTimeoutMsg || isDwTimeoutName) {
      isNetworkError = true;
      errorType = 'downstream';
      errorTypeDescription = 'timeouts';
    }
  }
  if (downstreamExceptions?.enable && downstreamExceptions?.replacePatterns?.length > 0 && hasServiceErrors) {
    // Downstream Exceptions Error
    const isDwExceptionsServiceErrMsg = downstreamExceptions?.replacePatterns?.find?.(
      (item) => errorNode?.serviceErrMsg && errorNode?.serviceErrMsg?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1,
    );
    const isDwExceptionsMsg = downstreamExceptions?.replacePatterns?.find?.(
      (item) => errorNode?.message && errorNode?.message?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1,
    );
    const isDwExceptionsName = downstreamExceptions?.replacePatterns?.find?.(
      (item) =>
        errorNode?.name &&
        errorNode?.name?.toLowerCase?.().indexOf(item?.toLowerCase?.()) !== -1 &&
        errorNode?.name?.toLowerCase?.().indexOf('_exception'?.toLowerCase?.()) === -1,
    );
    if (isDwExceptionsServiceErrMsg || isDwExceptionsMsg || isDwExceptionsName) {
      isNetworkError = true;
      errorType = 'downstream';
      errorTypeDescription = 'exceptions';
    }
  }
  let statusCode = response?.status || response?.response?.status;
  if ((isNetworkError || isAbortedError) && !errorNodeReceived && statusCode) {
    if (errorNode) {
      errorNode.id = statusCode;
    } else {
      errorNode = {};
      errorNode.id = statusCode;
    }
  } else if (isNetworkError && errorNodeReceived && errorNode.id) {
    statusCode = errorNode.id;
  }
  if (isNetworkError && statusCode && !errorType) {
    isNetworkError = true;
    errorType = 'soe';
    errorTypeDescription = 'timeout';
    if (errorNode) {
      errorNode.id = statusCode;
    } else {
      errorNode = {};
      errorNode.id = statusCode;
    }
  }
  if (isNetworkError && !errorType && !errorTypeDescription && !errorNode?.id) {
    errorType = 'soe';
    errorTypeDescription = 'Cancelled/Aborted';
    statusCode = 'CANCELLED/ABORTED';
  }
  // DO NOT USE, JUST FOR CHECKS
  const genericError = 'We are unable to process the request at this time. Please try after sometime';
  let devNote = '';

  // const errorNodeReceived = !!(errors?.length > 0);
  if (errorNodeReceived) {
    // Error Node exists
    devNote = 'Service Error Node Received - ';

    // Which message is being logged in loggerMessage.message?
    if (errorNode.networkMessage) {
      devNote += 'logged errorNode.networkMessage - ';
    } else if (errorNode.message) {
      devNote += 'logged errorNode.message - ';
    } else if (error && error.message) {
      devNote += 'logged error.message - ';
    }
  } else {
    devNote = 'No Service Error Node - ';
  }

  if (!message) {
    devNote += 'No message available';
  } else if (message === genericError) {
    devNote += 'Generic error message received';
  } else {
    devNote = ' Logged';
  }

  return {
    proactiveChatIndicator: errorNode ? errorNode.proactiveChatIndicator : null,
    proactiveChatCustomMSG: errorNode ? errorNode.proactiveChatCustomMSG : null,
    serviceUrl: response && response.config && response.config.url ? response.config.url : undefined,
    method: response && response.config && response.config.method ? response.config.method : undefined,
    message,
    name: errorNode && errorNode.name ? errorNode.name : undefined,
    id: errorNode && errorNode.id ? errorNode.id : undefined,
    errorCategory: errorNode && errorNode.errorCategory ? errorNode.errorCategory : undefined,
    loglevel: errorNode && errorNode.severity ? errorNode.severity : undefined,
    e2erequestid: response && response.headers ? response.headers.e2erequestid : undefined,
    subEventType: subEventType || (error && error.subEventType),
    stack: error && error.stack,
    hasResponse,
    hasServiceErrors,
    isGoToUrl,
    note: error && error.note,
    extraParams: error && error.extraParams,
    errorNodeReceived,
    devNote: devNote && devNote !== '' ? devNote : undefined,
    isServiceErrorMessage,
    namespace,
    serviceErrMsg,
    statusCode,
    isNetworkError,
    isAbortedError,
    cfeMsg,
    msgType,
    errorType,
    errorTypeDescription,
  };
};

const logError = (error, info) => {
  if (error)
    try {
      const windowError = error && error.error;

      let eventType = 'scriptError';
      let vendorSubEventType;
      if (error && error.eventType && error.eventType !== '') {
        // eslint-disable-next-line prefer-destructuring
        eventType = error.eventType; // Bug with eslint
      } else if (error && error.notification) {
        eventType = 'FeError';
      } else if (error && error.error) {
        eventType = 'globalScriptError';
      } else if (info) {
        eventType = 'componentScriptError';
      }

      let errorJSON;
      if (windowError) {
        errorJSON = getWindowErrorJSON(error);
      } else if (error.notification || error.json) {
        errorJSON = error;
      } else {
        errorJSON = getErrorJSON(error);
      }
      // No Error Message
      if (!errorJSON.message && error) {
        try {
          if (error.message) {
            errorJSON.message = error.message;
          } else {
            errorJSON.message = (errorJSON && errorJSON.stack) || (error && error.stack);
          }
        } catch (e) {
          console.log(e);
        }
      }
      const networkErrorJSON = errorJSON.networkError ? getNetworkJSON(errorJSON.networkError) : {};
      // Sub Event Types
      let subEventType = (error && error.subEventType) || (networkErrorJSON && networkErrorJSON.subEventType) || '';
      if (eventType === 'FeError') {
        if (errorJSON?.errorCategory === 'API-ERROR' && subEventType === 'FeErrorB') {
          subEventType = 'FeErrorB';
        } else if (errorJSON?.errorCategory === 'API-ERROR' && subEventType === 'FeErrorS') {
          subEventType = 'FeErrorS';
        } else if (errorJSON?.errorCategory === 'UIError' || (networkErrorJSON && networkErrorJSON.stack)) {
          subEventType = 'FeErrorJ'; // UI Catching error on service
        } else if (!networkErrorJSON || (networkErrorJSON && (!networkErrorJSON.serviceUrl || networkErrorJSON.serviceUrl === ''))) {
          subEventType = 'FeErrorB'; // Valid business Error or FE Validation
        } else {
          subEventType = 'FeErrorS'; // Service Error
        }
      }

      // Separating out errors by origin.
      let errorFromTealium = ['Script error.', 'Script error'].includes(errorJSON.message);
      if (errorJSON && errorJSON.stack) {
        const utagPath = 'https://tags.tiqcdn.com/utag/vzw/main/';
        errorFromTealium = errorFromTealium || errorJSON?.message?.includes(utagPath) || errorJSON?.stack?.includes(utagPath);
      }

      // const gnavPath = '/etc/designs/vzwcom/gnav20/';
      // const errorFromGnav = errorJSON.message.includes(gnavPath) || errorJSON.stack.includes(gnavPath);

      const errorFromDigital = error.filename && error.filename.indexOf('etc/clientlibs/vcg/home') > -1;

      // All errors originating outside of the Digital code base
      if ((eventType === 'scriptError' || eventType === 'globalScriptError') && (errorFromTealium || !errorFromDigital)) {
        vendorSubEventType = eventType;
        eventType = 'UI-ERROR';
      }

      const errorMessage = errorJSON?.message || networkErrorJSON?.message;
      let errorCode = '';
      const data = {
        messageType: 'ERROR',
        eventType,
        subEventType,
        vendorSubEventType,
        pageUrl: window.location.href,
        serviceUrl: errorJSON?.serviceUrl || networkErrorJSON?.serviceUrl || null,
        method: networkErrorJSON?.method || null,
        errorMessage: errorJSON?.message || '',
        subHeaderMessage: errorJSON?.subHeaderMessage || null,
        errorPage: errorJSON?.errorPage || null,
        errorType: networkErrorJSON?.errorType || undefined,
        errorTypeDescription: networkErrorJSON?.errorTypeDescription || undefined,
        // cookie: networkErrorJSON.e2erequestid || '', // digital_ig_session???
        serviceE2EId: errorJSON?.e2erequestid || networkErrorJSON?.e2erequestid || null,
        note: errorJSON?.note || networkErrorJSON?.note || '',
        pageName:
          window?.location.href
            ?.split('/')
            ?.pop()
            ?.split('?')
            ?.shift()
            ?.replace('.html', '') || '',
        cfeMsg: networkErrorJSON?.cfeMsg || false,
        msgType: networkErrorJSON?.msgType || 'NA',
        loggerMessage: {
          namespace: networkErrorJSON?.namespace || '',
          serviceErrMsg: networkErrorJSON?.serviceErrMsg || '',
          message: networkErrorJSON?.message || errorJSON?.message || '',
          loglevel: networkErrorJSON?.loglevel || null,
          id: networkErrorJSON?.id || null,
          name: networkErrorJSON?.name || null,
          errorCategory: networkErrorJSON?.errorCategory
            ? networkErrorJSON?.errorCategory
            : errorJSON?.errorCategory || (subEventType === 'FeErrorS' ? 'UNKNW' : ''),
          userAgent: navigator.userAgent,
          pageTitle: getPageName(), // document.title,
          browserName: getBrowserName(),
          host: window.location.host,
          stackTrace: errorJSON?.stack || networkErrorJSON?.stack,
          componentStack: info && info?.componentStack,
          isServiceErrorMessage: networkErrorJSON?.isServiceErrorMessage,
          statusCode: networkErrorJSON.statusCode,
        },
        isNseProspectFlow: getAPPID() === 'NSE',
        fraudResponse: errorJSON?.fraudResponse || null, // Used only for generic error page
        isGoToUrl: networkErrorJSON?.isGoToUrl || null, // curious as to how many are being logged and if these can be ommited.
        extraParams: networkErrorJSON?.extraParams || null, // to avoid additional changes in order to log data that is not common across networm errors.
        newSOELoggingChangesEnabled: window?.vzFlags?.newSOELoggingChangesEnabled || false,
        flowName: window?.vzdl?.page?.flow || '',
        // sessionStorage: window?.vzFlags?.sessionStorageLoggingEnabled && eventType !== 'vendorScriptError' ? getSessionStorageInfo() : undefined,
      };

      if (eventType === 'FeError') {
        try {
          if (
            window.vzFlags.proactiveChatIndicators &&
            window.vzFlags.proactiveChatIndicators.proactiveChatCustomMSG &&
            window.vzFlags.proactiveChatIndicators.proactiveChatIndicator &&
            window.vzFlags.proactiveChatIndicators.errorCode
          ) {
            /* eslint-disable prefer-destructuring */
            errorCode = window.vzFlags.proactiveChatIndicators.errorCode;
            /* eslint-enable */
          }
        } catch (ex) {
          console.log('Error in logger_new', ex);
        }
      }

      if (eventType === 'FeError') {
        logToContentSquare(subEventType || eventType, errorMessage);
      }
      if (eventType === 'FeError' && ['API-ERROR'].includes(errorJSON?.errorCategory)) {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar13: getDisplayMessage(networkErrorJSON?.id || errorCode, errorMessage),
            evar22: 'message displayed',
            evar25: networkErrorJSON?.id || errorCode,
          },
        });
      }

      if (networkErrorJSON?.id !== 'R1001') {
        jsNotifyAsDynamic(data);
      }
    } catch (err) {
      console.log('Error in logger_new', err);
    }
};

// common logger for success and warning
const loggerCommon = (data, logType) => {
  try {
    const networkJSON = data.networkData ? getNetworkJSON(data.networkData) : {};
    const message = data.message || networkJSON.message || '';
    const eventType = data.notification ? logType : data.eventType;

    // Sub Event Types
    let subEventType = (data && data.subEventType) || (networkJSON && networkJSON.subEventType) || '';
    if (eventType === logType) {
      if (!networkJSON || (networkJSON && (!networkJSON.serviceUrl || networkJSON.serviceUrl === ''))) {
        subEventType = `${logType}B`; // Valid business Error or FE Validation
      } else {
        subEventType = `${logType}S`; // Service Error
      }
    }

    const requestData = {
      eventType,
      subEventType,
      pageUrl: window.location.href,
      serviceUrl: networkJSON.serviceUrl,
      method: networkJSON.method,
      errorMessage: 'NA',
      message,
      subHeaderMessage: data.subHeaderMessage,
      serviceE2EId: networkJSON.e2erequestid,
      note: data.note || networkJSON.note,
      loggerMessage: {
        message: message || '',
        userAgent: navigator.userAgent,
        pageTitle: getPageName(), // document.title,
        host: window.location.host,
      },
      isNseProspectFlow: getAPPID() === 'NSE',
      extraParams: data.extraParams || networkJSON.extraParams, // to avoid additional changes in order to log data that is not common across networm errors.
    };

    // Content Square Reporting
    if (eventType === 'FeWarning') {
      logToContentSquare(eventType, message);
    }

    if (logType === 'FeWarning') {
      requestData.messageType = 'WARNING';
      if (window?.vzFlags?.warningLoggingEnabled && !window?.vzFlags?.stopServices) {
        jsNotifyAsDynamic(requestData);
      }
    } else if (logType === 'FeSuccess') {
      requestData.messageType = 'SUCCESS';
      // if (window?.vzFlags?.successLoggingEnabled && !window?.vzFlags?.stopServices) {
      jsNotifyAsDynamic(requestData);
      // }
    }
  } catch (err) {
    console.log(err);
  }
};

const logWarning = (data) => {
  loggerCommon(data, 'FeWarning');
};

const logSuccess = (data) => {
  loggerCommon(data, 'FeSuccess');
};

const logInfo = (data) => {
  try {
    const networkJSON = data.networkData ? getNetworkJSON(data.networkData) : {};
    const message = data.message || networkJSON.message || '';
    const eventType = data.notification ? 'FeInfo' : data.eventType;

    // Sub Event Types
    let subEventType = (data && data.subEventType) || (networkJSON && networkJSON.subEventType) || '';
    if (eventType === 'FeInfo') {
      if (!networkJSON || (networkJSON && (!networkJSON.serviceUrl || networkJSON.serviceUrl === ''))) {
        subEventType = 'FeInfoB'; // Valid business Error or FE Validation
      } else {
        subEventType = 'FeInfoS'; // Service Error
      }
    }

    const requestData = {
      messageType: 'INFO',
      eventType,
      subEventType,
      pageUrl: window.location.href,
      serviceUrl: networkJSON?.serviceUrl || null,
      method: networkJSON?.method || null,
      errorMessage: 'NA',
      message,
      subHeaderMessage: data?.subHeaderMessage ? data.subHeaderMessage : null,
      serviceE2EId: networkJSON.e2erequestid,
      note: data?.note || networkJSON?.note,
      loggerMessage: {
        message: message || '',
        userAgent: navigator?.userAgent ? navigator.userAgent : null,
        pageTitle: getPageName(), // document.title,
        host: window.location.host,
      },
      isNseProspectFlow: !isLoggedIn(),
      extraParams: data.extraParams || networkJSON.extraParams, // to avoid additional changes in order to log data that is not common across networm errors.
    };

    if (eventType === 'FeInfo') {
      logToContentSquare(eventType, message);
    }
    // if (window?.vzFlags?.infoLoggingEnabled && !window?.vzFlags?.stopServices) {
    jsNotifyAsDynamic(requestData);
    // }
  } catch (err) {
    console.log(err);
  }
};

const logger = (data, info) => {
  try {
    if (data) {
      if (
        data?.messageType === 'ERROR' ||
        data?.eventType === 'BLOCKER' ||
        data?.eventType === 'FE_API_ERROR' ||
        data?.eventType === 'FE_API_JS_ERROR' ||
        data?.eventType === 'FeError' ||
        ['scriptError', 'FeError', 'componentScriptError'].includes(data?.eventType)
      ) {
        logError(data, info);
      } else if (data.messageType === 'WARNING' || data?.eventType === 'FeWarning') {
        logWarning(data, info);
      } else if (data.messageType === 'SUCCESS' || data?.eventType === 'FeSuccess') {
        logSuccess(data, info);
      } else if (data.messageType === 'INFO' || data?.eventType === 'INFO' || data?.eventType === 'FeInfo') {
        logInfo(data, info);
      } else {
        logError(data, info);
      }
    } else {
      logError(data, info);
    }
  } catch (error) {
    // NOOP
  }
};

export default logger;
